// Known email providers — covers ~95% of FarmFlix signups
const KNOWN_DOMAINS = [
  "gmail.com",
  "googlemail.com",
  "icloud.com",
  "hotmail.com",
  "hotmail.co.uk",
  "outlook.com",
  "outlook.co.uk",
  "yahoo.com",
  "yahoo.co.uk",
  "live.com",
  "live.co.uk",
  "eircom.net",
  "aol.com",
  "protonmail.com",
  "me.com",
  "msn.com",
  "btinternet.com",
  "sky.com",
  "virginmedia.com",
  "talktalk.net",
  "mail.com",
];

// TLDs that don't exist but are common keyboard typos
const INVALID_TLDS = [
  "con",
  "cpm",
  "vom",
  "ocm",
  "comm",
  "cim",
  "cm",
  "couk",
  "xom",
  "cok",
  "col",
  "coom",
  "ckm",
  "clm",
  "c0m",
  "om",
  "ccom",
  "cob",
  "coj",
  "cmo",
];

function levenshtein(a, b) {
  const matrix = [];
  for (let i = 0; i <= b.length; i++) matrix[i] = [i];
  for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      matrix[i][j] =
        b[i - 1] === a[j - 1]
          ? matrix[i - 1][j - 1]
          : Math.min(
              matrix[i - 1][j - 1] + 1,
              matrix[i][j - 1] + 1,
              matrix[i - 1][j] + 1,
            );
    }
  }
  return matrix[b.length][a.length];
}

/**
 * Validator: rejects emails with obviously fake TLDs.
 * Returns an error string (blocks form submission) or undefined.
 */
export const isEmailDomainValid = (value) => {
  if (!value || !value.includes("@")) return undefined;
  const domain = value.split("@")[1] || "";
  const tld = domain.split(".").pop().toLowerCase();
  if (INVALID_TLDS.includes(tld)) {
    return `"${domain}" doesn't look right. Did you mean ".com"?`;
  }
  return undefined;
};

/**
 * Returns a corrected email suggestion, or null if no suggestion.
 * Non-blocking — used for "Did you mean?" UI hint.
 */
export const getEmailSuggestion = (value) => {
  if (!value || !value.includes("@")) return null;
  const parts = value.split("@");
  const localPart = parts[0];
  const domain = (parts[1] || "").toLowerCase();

  // Exact match to a known domain — no suggestion needed
  if (KNOWN_DOMAINS.includes(domain)) return null;

  // Find the closest known domain within edit distance 2
  let bestMatch = null;
  let bestDistance = 3; // threshold: only suggest if distance <= 2

  for (const known of KNOWN_DOMAINS) {
    const distance = levenshtein(domain, known);
    if (distance > 0 && distance < bestDistance) {
      bestDistance = distance;
      bestMatch = known;
    }
  }

  if (bestMatch) {
    return `${localPart}@${bestMatch}`;
  }
  return null;
};
